export const AUTH0_CLIENT_DOMAIN = import.meta.env.VITE_APP_AUTH0_CLIENT_DOMAIN;
/**
 * Auth0's own tenant domain (e.g. csihelsinkioy.eu.auth0.com). Used where the task pane itself
 * navigates to Auth0 (Mac login, logout): Office only allows that for domains in the manifest's
 * AppDomains, and installed manifests may list only the tenant domain. Defaults to the client domain.
 */
export const AUTH0_TENANT_DOMAIN =
  import.meta.env.VITE_APP_AUTH0_TENANT_DOMAIN || import.meta.env.VITE_APP_AUTH0_CLIENT_DOMAIN;
export const AUTH0_CLIENT_ID = import.meta.env.VITE_APP_AUTH0_CLIENT_ID;
export const AUTH0_AUDIENCE = import.meta.env.VITE_APP_AUTH0_AUDIENCE;

export const LOCIZE_PROJECT_ID = import.meta.env.VITE_APP_LOCIZE_PROJECT_ID;
export const LOCIZE_API_KEY = import.meta.env.VITE_APP_LOCIZE_API_KEY;
export const SENTRY_DSN = import.meta.env.VITE_APP_SENTRY_DSN;
export const SENTRY_ENVIRONMENT = import.meta.env.VITE_APP_SENTRY_ENVIRONMENT || 'development';
export const NODE_ENV = import.meta.env.NODE_ENV;

export const CSI_VENDOR_KEY = import.meta.env.VITE_APP_CSI_VENDOR_KEY;
export const CSI_VENDOR_APP_KEY = import.meta.env.VITE_APP_CSI_VENDOR_APP_KEY;

export const FIREBASE_API_KEY = import.meta.env.VITE_FIREBASE_API_KEY;
export const FIREBASE_AUTH_DOMAIN = import.meta.env.VITE_FIREBASE_AUTH_DOMAIN;
export const FIREBASE_PROJECT_ID = import.meta.env.VITE_FIREBASE_PROJECT_ID;
export const FIREBASE_STORAGE_BUCKET = import.meta.env.VITE_FIREBASE_STORAGE_BUCKET;
export const FIREBASE_MESSAGING_SENDER_ID = import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID;
export const FIREBASE_APP_ID = import.meta.env.VITE_FIREBASE_APP_ID;
export const FIREBASE_MEASUREMENT_ID = import.meta.env.VITE_FIREBASE_MEASUREMENT_ID;

export const KUBERNETES_NAMESPACE = import.meta.env.VITE_KUBERNETES_NAMESPACE;
export const KUBERNETES_POD_NAME = import.meta.env.VITE_KUBERNETES_POD_NAME;
export const KUBERNETES_POD_IP = import.meta.env.VITE_KUBERNETES_POD_IP;
export const KUBERNETES_NODE_NAME = import.meta.env.VITE_KUBERNETES_NODE_NAME;
